<div class="flex h-screen w-full overflow-clip">
  <aside
    class="hidden lg:flex flex-shrink-0 bg-bluegray-900 transition-all duration-300 ease-in-out flex flex-col z-40 w-16"
  >
    <div
      class="h-16 flex items-center justify-center border-b border-bluegray-800"
    >
      <app-logo [collapsed]="true" />
    </div>

    <nav
      class="flex-1 overflow-y-auto py-6 scrollbar-thin"
      aria-label="Menu de navegação"
    >
      <app-menu [items]="(menuItems$ | async) ?? []" [isCollapsed]="true" />
    </nav>
  </aside>

  <div class="flex-1 flex flex-col min-w-0 bg-gray-50 overflow-clip relative">
    <div class="fixed top-0 left-0 right-0 z-50 lg:static lg:z-30">
      <app-topbar />
    </div>

    <main
      class="admin-layout-main min-h-0 flex-1 overflow-y-auto pt-[72px] pb-0 lg:pt-0 lg:pb-0"
    >
      <div
        [ngClass]="{
          'px-4 py-4 pb-[160px] lg:px-6 lg:py-6 lg:pb-6': usarPaddingPadrao(),
          'max-w-[1600px] mx-auto': usarPaddingPadrao(),
        }"
      >
        <router-outlet />
      </div>
    </main>

    <nav
      aria-label="Navegação inferior móvel"
      class="lg:hidden fixed bottom-0 left-0 right-0 h-20 bg-bluegray-900 border-t border-bluegray-800 flex items-center justify-around px-2 z-40"
    >
      @for (item of (menuItems$ | async) ?? []; track item.label) {
        <a
          [routerLink]="item['route']"
          routerLinkActive="active"
          #rla="routerLinkActive"
          class="flex flex-col items-center gap-1 flex-1 min-w-0 group"
        >
          <div
            class="px-5 py-1 rounded-full transition-all duration-200"
            [ngClass]="
              rla.isActive
                ? 'bg-white text-bluegray-900'
                : 'text-bluegray-400 hover:text-white'
            "
          >
            <i [class]="item.icon" class="!text-[32px] block"></i>
          </div>
          <span
            class="text-[10px] font-bold uppercase tracking-wider truncate w-full text-center transition-colors duration-200"
            [ngClass]="rla.isActive ? 'text-white' : 'text-bluegray-400'"
          >
            {{ item.label }}
          </span>
        </a>
      }
    </nav>
  </div>
</div>

<app-backdrop [visible]="(loading$ | async) ?? false">
  <app-spinner [loading]="true" />
</app-backdrop>
